import { render, staticRenderFns } from "./apptfees.vue?vue&type=template&id=e0456ea8&scoped=true&"
import script from "./apptfees.vue?vue&type=script&lang=js&"
export * from "./apptfees.vue?vue&type=script&lang=js&"
import style0 from "./apptfees.vue?vue&type=style&index=0&id=e0456ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0456ea8",
  null
  
)

export default component.exports